import { Dispatch } from "redux";

// types
import { IAuthActionTypes } from "models/IAuthState";
import { IHistory } from "models/ICommon";

// services
import authService from "services/authService";

// configs
import { PATH_NAME } from "configs";
import { IAppActionTypes } from "models/IAppState";

type otpResponse = {
  data?: {
    user_id: string;
    entity_id: string;
    auth_token: string;
    user_name: string;
  };
  error?: any;
};

export const sendotp =
  (mobile: string, entityid: string) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: IAuthActionTypes.OTP_REQUEST });

    try {
      const response: otpResponse = await authService.sendotp(mobile, entityid);

      if (response.error) {
        dispatch({
          type: IAuthActionTypes.OTP_FAILURE,
          payload: {
            otperrormessage: "Invalid Mobile",
          },
        });

        // dispatch({
        //   type: IAppActionTypes.ENQUEUE_SNACKBAR,
        //   payload: {
        //     message: "Invalid Mobile",
        //     variant: "error",
        //     key: 'invalidmobile'
        //   }
        // })

        setTimeout(() => {
          dispatch({
            type: "HIDE_ALERT",
          });
        }, 2000);

        return;
      }

      dispatch({
        type: IAppActionTypes.ENQUEUE_SNACKBAR,
        payload: {
          message: `Sent OTP successfully to ${mobile}`,
          variant: "success",
          key: "sendotp",
        },
      });

      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);

      dispatch({
        type: IAuthActionTypes.OTP_SUCCESS,
        payload: { ...response.data },
      });
    } catch (error) {
      console.log("ERROR ", error);
      dispatch({
        type: IAuthActionTypes.OTP_FAILURE,
        payload: {
          otperrormessage: "Failed To send OTP ",
        },
      });
      setTimeout(() => {
        dispatch({
          type: "HIDE_ALERT",
        });
      }, 2000);
    }
  };

export const raise_toast_message =
  (message: string, type: string = "success", modoule: string = "sendotp") =>
  async (dispatch: Dispatch<any>) => {
    dispatch({
      type: IAppActionTypes.ENQUEUE_SNACKBAR,
      payload: {
        message: message,
        variant: type,
        key: modoule,
      },
    });

    let timeoutID = setTimeout(() => {
      dispatch({
        type: "HIDE_ALERT",
      });
      clearTimeout(timeoutID);
    }, 1500);
  };

export const verifyotp =
  (
    otp: string,
    mobile: string,
    user_id: string | undefined,
    verifytoken: string,
    isOtpFlow?: boolean,
    isFrFlow?: boolean,
    isOtpAndLoginFlow?: boolean
  ) =>
  async (dispatch: Dispatch<any>) => {
    dispatch({ type: IAuthActionTypes.VERIFY_OTP_REQUEST });
    console.log("verifytoken", verifytoken);
    const response = await authService.verifyotp(
      otp,
      mobile,
      user_id,
      verifytoken,
      isOtpFlow,
      isFrFlow,
      isOtpAndLoginFlow
    );
    if (response.error) {
      dispatch({
        type: IAuthActionTypes.VERIFY_OTP_FAILURE,
        payload: {
          otperrormessage: "Invalid otp",
        },
      });
      dispatch({
        type: IAppActionTypes.ENQUEUE_SNACKBAR,
        payload: {
          message: "Invalid OTP",
          variant: "error",
          key: "invalidotp",
        },
      });
      return;
    }
    dispatch({
      type: IAuthActionTypes.VERIFY_OTP_SUCCESS,
      payload: { ...response },
    });
    dispatch({
      type: IAppActionTypes.ENQUEUE_SNACKBAR,
      payload: {
        message: `verified OTP successfully`,
        variant: "success",
        key: "sendotp",
      },
    });

    setTimeout(() => {
      dispatch({
        type: "HIDE_ALERT",
      });
    }, 2000);
  };

export const cancelotp = () => async (dispatch: Dispatch<any>) => {
  dispatch({ type: IAuthActionTypes.OTP_CANCEL });
};

export const logout = () => (dispatch: Dispatch<any>) => {
  authService.logOut();
  dispatch({ type: IAuthActionTypes.LOGOUT });
};

export const setUserData =
  (user: string, role: string) => (dispatch: Dispatch<any>) => {
    dispatch({
      type: IAuthActionTypes.SILENT_LOGIN,
      payload: { user, role },
    });
  };

export const fetchCurrentUserInfo = () => async (dispatch: Dispatch<any>) => {
  const response = await authService.fetchCurrentUser();

  if (response?.status == 200) {
    dispatch({
      type: IAuthActionTypes.FETCH_CURRENT_USER_SUCCESS,
      payload: { ...response.data?.data },
    });
  }
};

export const verify_fr =
  (image: string, image2: string, user_id: string, authtoken: string) =>
  async (dispatch: Dispatch<any>) => {
    dispatch({ type: IAuthActionTypes.LOGIN_FR_VERIFY_REQUEST });

    const response: otpResponse = await authService.verify_fr(
      image,
      image2,
      user_id,
      authtoken
    );

    if (response.error) {
      dispatch({
        type: IAuthActionTypes.LOGIN_FR_VERIFY_FAILURE,
        payload: {
          error: response.error,
        },
      });

      return;
    }

    dispatch({
      type: IAuthActionTypes.LOGIN_FR_VERIFY_SUCCESS,
      payload: { ...response },
    });
  };
